import { createContext, useContext, useState, useEffect, useCallback } from 'react';
import api from '@/lib/api';
import { DEFAULT_RATES, mergeRates } from '@/lib/generation';

const RatesContext = createContext({ rates: DEFAULT_RATES, activeTeamId: null, refreshRates: () => {} });

export const useRates = () => useContext(RatesContext);

export function RatesProvider({ children }) {
  const [rates, setRates] = useState(DEFAULT_RATES);
  const [activeTeamId, setActiveTeamId] = useState(null);

  const refreshRates = useCallback(async () => {
    if (!localStorage.getItem('ff_token')) return;
    try {
      const res = await api.get('/teams');
      const teams = res.data || [];
      const active = teams.find(t => t.is_active) || teams[0] || null;
      setActiveTeamId(active?.id || null);
      setRates(active?.cost_rates ? mergeRates(active.cost_rates) : DEFAULT_RATES);
    } catch { /* keep defaults */ }
  }, []);

  useEffect(() => { refreshRates(); }, [refreshRates]);

  return (
    <RatesContext.Provider value={{ rates, activeTeamId, refreshRates }}>
      {children}
    </RatesContext.Provider>
  );
}
